import { FC, memo } from 'react';
import { AiOutlineFileSearch } from 'react-icons/ai';

import { formatClassificacao } from '../../../../../../utils/formatClassificacao';
import { QualidadeItem } from '../../page';
import { QualityCardContainer } from './styles';

interface IQualityCard {
  analysis: QualidadeItem;
  onVisualize: (analysis: QualidadeItem) => void;
}

const QualityCard: FC<IQualityCard> = memo(({ analysis, onVisualize }) => {
  const handleVisualize = () => {
    onVisualize(analysis);
  };

  return (
    <QualityCardContainer>
      <div className="card-title">
        <AiOutlineFileSearch />
        <h1>Análise #{analysis.DFIDCALCANALISE}</h1>
      </div>

      <div className="quality-item-row">
        <div className="item-row-medium-with-border">
          <span>
            <strong>Classificação:</strong>{' '}
            {formatClassificacao(analysis.DFCLASSIFICADO)}
          </span>
        </div>
        <div className="item-row-medium">
          <span>
            <strong>Matrícula:</strong> {analysis.DFMATRICULA}
          </span>
        </div>
      </div>

      <div className="quality-item-row">
        <div className="item-row-medium-with-border">
          <span>
            <strong>Produtor:</strong> {analysis.DFNOMEPRODUTOR}
          </span>
        </div>
        <div className="item-row-medium">
          <span>
            <strong>Propriedade:</strong> {analysis.DFNOMEPROPRIEDADE}
          </span>
        </div>
      </div>

      <div className="quality-item-row">
        <div className="item-row-medium">
          <span>
            <strong>CPF/CNPJ:</strong> {analysis.DFCNPJCPFCEI}
          </span>
        </div>
      </div>

      <footer className="card-footer">
        <button className="visualize" onClick={handleVisualize}>
          Visualizar
        </button>
      </footer>
    </QualityCardContainer>
  );
});

QualityCard.displayName = 'QualityCard';

export { QualityCard };
